module.exports = __webpack_public_path__ + "img/app-store-badge-2@3x.ba5f5c04.png";